export default __webpack_public_path__ + "static/media/contacthover.0d9b3484.svg";